import * as Yup from "yup";
import {yupRequiredString} from "../yup/Validators";

export const CreateProductTypeSchema = Yup.object().shape({
  name: yupRequiredString,
})
